// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2haCG","title":"styles_title__109_S"};